import {classes, StyledNoData} from './SummaryComponentStyles'
import {Box, Paper, Stack, Typography} from '@mui/material'
import PropTypes from 'prop-types'
import {ReactComponent as CellIcon} from '../../../icons/Personas/Cell.svg'
import {ReactComponent as WebIcon} from '../../../icons/Personas/Web.svg'
import {ReactComponent as MailIcon} from '../../../icons/Personas/Mail.svg'
import {ReactComponent as EmailIcon} from '../../../icons/Personas/Email.svg'
import {ReactComponent as TextIcon} from '../../../icons/Personas/Text Messages.svg'
import {ReactComponent as PhoneIcon} from '../../../icons/Personas/Phone.svg'
import {SuperscriptGreyDagger} from '../../common/Dagger'

const SummaryCommunicationData = ({data, isZeroCountPopulation}) => {
  const getIcon = (text) => {
    switch (String(text).toLowerCase()) {
      case 'email':
        return <EmailIcon aria-hidden="true" />
      case 'cell':
        return <CellIcon aria-hidden="true" />
      case 'web':
        return <WebIcon aria-hidden="true" />
      case 'mail':
        return <MailIcon aria-hidden="true" />
      case 'text':
        return <TextIcon aria-hidden="true" />
      case 'phone':
        return <PhoneIcon aria-hidden="true" />
      default:
        break
    }
  }

  return (
    <Box className={classes.summaryDataBox}>
      <Paper elevation={1} className={classes.summaryPadding}>
        <Stack spacing={{xs: 1, sm: 1}} direction="row" useFlexGap className={classes.summaryCommMainStack}>
          {isZeroCountPopulation ? (
            <StyledNoData>
              No data to display <SuperscriptGreyDagger />
            </StyledNoData>
          ) : (
            data.map((item, index) => (
              <Stack
                className={classes.summaryCommStack}
                key={index + item.title}
                tabIndex={0}
                aria-label={`${item.title}, ${item.text}`}
              >
                <Typography className={classes.summarySubtitle} aria-hidden="true">
                  {getIcon(item.title)}
                </Typography>
                <Typography className={[classes.summaryStackSubTitle, classes.summaryTitleColorTeal]}>
                  {item.title}
                </Typography>
                <Typography className={classes.summaryStackText}>{item.text}</Typography>
              </Stack>
            ))
          )}
        </Stack>
      </Paper>
    </Box>
  )
}

SummaryCommunicationData.propTypes = {
  data: PropTypes.array.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired
}

export default SummaryCommunicationData
